import React from 'react';
import { Input, InputNumber, Select } from 'antd';
import vdns_api from '../../services/vdns_api';
import Config from '../../Config';

const Option = Select.Option;

/* eslint-disable react/display-name */
function formatISO8601Time(timeString) {
  if (timeString === null) {
    return '???';
  }

  /* ISO8601 date format regex from https://www.regextester.com/94925 */
  const regex = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\.[0-9]+)?(Z)?$/g;
  const result = regex.exec(timeString);

  if (result.length < 7) {
    return '???';
  }
  return `${result[3]}/${result[2]}/${result[1]} ${result[4]}:${result[5]}:${result[6]}`;
}

export async function getRecordsTableColumns(authToken) {
  // A temporary solution to return all clusters in one page
  const clusters = await vdns_api.getAllClusters(authToken, { limit: 100 });

  return [
    {
      title: 'Domain',
      dataIndex: 'realm',
      editable: true,
      getInput: () => <Input />,
      width: '11%',
      required: true,
    },
    {
      align: 'center',
      title: 'Record Type',
      dataIndex: 'type',
      editable: true,
      getInput: () => {
        return (
          <Select>
            <Option value="WILDCARD">WILDCARD</Option>
            <Option value="ANY">ANY</Option>
            <Option value="MX">MX</Option>
            <Option value="TXT">TXT</Option>
          </Select>
        );
      },
      filters: [{
        text: 'WILDCARD',
        value: 'WILDCARD',
      }, {
        text: 'ANY',
        value: 'ANY',
      }, {
        text: 'MX',
        value: 'MX',
      }, {
        text: 'TXT',
        value: 'TXT',
      }],
      width: '6%',
      required: true
    },
    {
      align: 'center',
      title: 'TTL',
      dataIndex: 'ttl',
      editable: true,
      getInput: () => <InputNumber
        style={ { width: '70px' } }
        min={Config.TTL_MIN_VAL}
        max={Config.TTL_MAX_VAL}
      />,
      width: '5%'
    },
    {
      align: 'center',
      title: 'Account ID',
      dataIndex: 'accountId',
      editable: true,
      getInput: () => <Input></Input>,
      width: '18%',
      required: true
    },
    {
      align: 'center',
      title: 'Status',
      dataIndex: 'adminStatus',
      render: function(text, record, id) {
        return record.adminStatus === 1 ? 'Enabled' : 'Disabled';
      },
      editable: true,
      getInput: () => {
        return(
          <Select>
            <Option value={1}>Enabled</Option>
            <Option value={0}>Disabled</Option>
          </Select>
        );
      },
      width: '5%'
    },
    {
      align: 'center',
      title: 'Cluster',
      dataIndex: 'clusterId',
      editable: true,
      render: function(text, record, id) {
        const cluster = clusters && clusters.data.find(cluster => cluster.id === record.clusterId);
        return cluster.name;
      },
      getInput: () => {
        return (
          <Select dropdownMatchSelectWidth={false}>
            { clusters && clusters.data.map(cluster => (<Option value={cluster.id} key={cluster.id}>{cluster.name}</Option>))}
          </Select>
        );
      },
      width: '5%'
    },
    {
      align: 'center',
      title: 'Priority',
      dataIndex: 'priority',
      editable: true,
      getInput: () => <InputNumber
        style={ { width: '70px' } }
        min={Config.PRIORITY_MIN_VAL}
        max={Config.PRIORITY_MAX_VAL}
      />,
      width: '5%'
    },
    {
      align: 'center',
      title: 'Content',
      dataIndex: 'content',
      editable: true,
      getInput: () => <Input></Input>,
      width: '19%',
      required: true
    },
    {
      align: 'center',
      title: <><div>Last Modified</div><div>(DD/MM/YY HH:MM:SS)</div></>,
      dataIndex: 'lastmodified',
      render: function(text, record, id) {
        return formatISO8601Time(record.lastmodified);
      },
      editable: false,
      width: '10%'
    },
    {
      align: 'center',
      title: <><div>Created</div><div>(DD/MM/YY HH:MM:SS)</div></>,
      dataIndex: 'created',
      render: function(text, record, id) {
        return formatISO8601Time(record.created);
      },
      editable: false,
      width: '10%'
    },
  ];
}

export const defaultRecord = {
  accountId: '',
  adminStatus: 1,
  clusterId: 1,
  realm: '',
  ttl: 300,
  type: 'ANY',
};
